import {Component} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-image-crop',
  templateUrl: './image-crop.component.html',
  styleUrls: ['./image-crop.component.scss'],
  standalone: false,
})
export class ImageCropComponent {
  base64 = '';
  image = '';
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  callback: (base64: string) => void = () => {};

  constructor(public bsModalRef: BsModalRef) {}

  onSubmit(): void {
    this.bsModalRef.hide();
    this.base64 = this.image;
    setTimeout(() => {
      this.callback(this.base64);
    }, 1000);
  }

  onClose(): void {
    this.bsModalRef.hide();
    setTimeout(() => {
      this.callback('');
    }, 1000);
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  imageCropped(event: any): void {
    this.image = event.base64;
  }
}
